module.exports = __webpack_public_path__ + "static/binder2-e2f75babf058482bed31584c32c08c84.png";